/**
 * @name AuthService
 * @description Servicio para la autenticación de usuario (Login y Logout)
 * @author Ricardo Guerra
 */

import axios from 'axios';
import moment from 'moment';
import { Environment } from '@config';
// import CryptoJS from 'crypto-js';

const authData = JSON.parse(localStorage.getItem('ls.authorizationData'));

// Información de autenticación
let authentication = {
  isAuth: (authData && authData.expirationDate && (new Date() < new Date(authData.expirationDate))) || false
};

/**
 * Consulta si el usuario está autenticado
 * @return {boolean} isAuth
 */
const isAuth = () => {
  const authorizationData = JSON.parse(localStorage.getItem('ls.authorizationData')) || false;
  return (authorizationData && authorizationData.expirationDate && (new Date() < new Date(authorizationData.expirationDate)));
};

// URL Authentication Endpoint
const BASE_URL = Environment.getCurrent().endpoints.auth;

/**
 * Iniciar sesión
 * @param {object} data { user, password }
 * @return {any} promise
 */
const login = (loginData) => {
  const clientId = Environment.getCurrent().clientId;

  // eslint-disable-next-line no-undef
  // const secretKey = CryptoJS.enc.Utf8.parse(process.env.SECRET_KEY);  // La clave debe ser la misma que en C#
  // const iv = CryptoJS.enc.Hex.parse('1234567890abcdef');  // IV igual que en C#

  // // Encriptar username y password usando CryptoJS
  // const encryptedUserName = CryptoJS.DES.encrypt(loginData.userName, secretKey, {
  //   iv,
  //   mode: CryptoJS.mode.CBC,
  //   padding: CryptoJS.pad.Pkcs7
  // }).toString();

  // const encryptedPassword = CryptoJS.DES.encrypt(loginData.password, secretKey, {
  //   iv,
  //   mode: CryptoJS.mode.CBC,
  //   padding: CryptoJS.pad.Pkcs7
  // }).toString();
  const encryptedUserName = loginData.userName;
  const encryptedPassword = loginData.password;

  const authData = `grant_type=password&username=${encodeURIComponent(encryptedUserName)}&password=${encodeURIComponent(encryptedPassword)}&client_id=${clientId}`;

  let userLang = navigator.language || navigator.userLanguage;
  let croppedLang = userLang.split('-')[0];

  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept-Language': croppedLang
  };

  // NOTA: Desde el Login se envía siempre en TRUE useRefreshTokens
  return axios.post(BASE_URL, authData, { headers })
    .then(({ data }) => {
      // Guardar información de autenticación en LocalStorage (tokens, fecha, etc.)
      if (loginData.useRefreshTokens) {
        localStorage.setItem('ls.authorizationData', JSON.stringify({
          token: data.access_token,
          refreshToken: data.refresh_token,
          userName: data.userName,
          useRefreshTokens: true,
          expirationDate: moment().add(data.expires_in, 'seconds')
        }));
      } else {
        localStorage.setItem('ls.authorizationData', JSON.stringify({
          token: data.access_token,
          refreshToken: '',
          userName: data.userName,
          useRefreshTokens: false,
          expirationDate: moment().add(data.expires_in, 'seconds')
        }));
      }

      if (loginData.keepSession) {
        localStorage.setItem('ls.credentials', JSON.stringify({
          userName: loginData.userName,
          password: data.pwd,
        }));
      }

      localStorage.setItem('creds', JSON.stringify({
        userName: loginData.userName,
        password: data.pwd,
      }));

      authentication.isAuth = true;
      return data;
    });
};

/**
 * Cerrar sesión
 */
const logout = () => {
  authentication.isAuth = false;
  const currentEnvironment = Environment.getCurrent();
  let URL = currentEnvironment.domain;
  window.location.href = `${URL.substring(0, URL.length - 2)}talentry/#/login`;
};

/** 
 * Limpiar LocalStorage
 */
const clearStorage = () => {
  // localStorage.clear();
  localStorage.removeItem('ls.authorizationData');
  localStorage.removeItem('ls.credentials');
  localStorage.removeItem('creds');
  localStorage.removeItem('ls.infoUsuario');
  localStorage.removeItem('ID');
};

const recaptchaValidation = (token) => {
  const postData = {
    key: token
  };

  let enviroment = `${Environment.getCurrent().endpoints.admin}/Token/Recaptcha`;

  return axios.post(enviroment, postData)
    .then(({ data }) => {
      return data;
    });
};


export const AuthService = {
  login,
  logout,
  clearStorage,
  isAuth,
  authentication,
  recaptchaValidation
};